// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","nav":"Header_nav__J8WFt","links":"Header_links__W4UhB","link":"Header_link__xIhZh","item":"Header_item__IvEBm"};